import { HttpErrorResponse } from "@angular/common/http";
import { ErrorHandler, Injectable } from "@angular/core";
import Swal from "sweetalert2";
import { AppAuthService } from "./services/auth.service";
import { AppModalService } from "./services/modal.service";

@Injectable({ providedIn: "root" })
export class AppErrorHandler implements ErrorHandler {
  constructor(
    private readonly appModalService: AppModalService,
    private readonly authService: AppAuthService
  ) { }

  async handleError(error: any) {
    if (error instanceof HttpErrorResponse) {
      switch (error.status) {
        case 0:
          // Swal.fire(
          //   'Oops...',
          //   'Algo deu errado!',
          //   'error'
          // );
          return;
        case 422: {
          Swal.fire(
            'Oops...',
            error?.error && error?.error != "" ? error?.error : 'Algo deu errado!',
            'error'
          );
          return;
        }
        case 401: {
          await this.authService.signout();
          return;
        }
      }
    }

    //console.error(error);
  }
}
